export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function adminApi(path, options = {}) {
  const response = await fetch(`${API}${path}`, {
    ...options, credentials: "include",
    headers: { ...(options.body && !(options.body instanceof FormData) ? { "Content-Type": "application/json" } : {}), ...options.headers },
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const detail = Array.isArray(body.detail) ? body.detail.map((e) => `${e.loc?.slice(2).join(" → ")}: ${e.msg}`).join("; ") : body.detail;
    throw new Error(response.status === 401 || response.status === 403 ? "Your session has ended or this account is not authorized. Sign in again." : detail || "Could not save changes. Please try again.");
  }
  return response.json();
}